const cardStyles = (theme) => ({
  [theme.breakpoints.up("md")]: {
    padding: " 16px",
    marginX: "0px",
    mt:8,
    maxWidth: "280px",
  },
  background: "#FBEBCB",
  width: "100%",
  padding: "16px",
  my: "10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});


const typographyStyles = {
  textAlign: "left",
  lineHeight: "32px",
  width: "100%",
};

const gridStyles = {
  paddingTop: "10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width:1
};

const buttonStyles = {
  background: "white",
  color: "#37773E",
  margin: "15px 0px",
  "&:hover": {
    color: "white",
  },
  borderRadius:'4px'
};

const buttonStyles2 = {
  background: "white",
  color: "#37773E",
  margin: "15px 0px",
  "&:hover": {
    color: "white",
  },
  borderRadius:'4px',
  pl:0,
  pr:0
};

export { cardStyles, typographyStyles, gridStyles, buttonStyles , buttonStyles2 };
